import React from "react"
import { Input, InputNumber, TooltipSystem, Label, Select, Comment, DatePicker, UploadFile, RadioList, Fields, Button, CheckBox, AutoComplete, Divider, Gender, IconButton, Editor, Textarea, InputBase, Switch, CheckboxList } from 'components/Form'
import { SpaceBetween } from "styles/GlobalStyle"
import DataGrid from "components/DataGrid"

const fieldsTyps = {
    input: (props) => <Input {...props} />,
    select: (props) => <Select {...props} />,
    datePicker: (props) => <DatePicker {...props} />,
    switch: (props) => <Switch {...props} />,
    uploadFile: (props) => <UploadFile {...props} />,
    checkboxList: (props) => <CheckboxList {...props} />,
    custom: (props) => <props.customComponent {...props} />,
    radio: (props) => <RadioList {...props} />,
    textarea: (props) => <Textarea {...props} />,
    inputNumber: (props) => <InputNumber {...props} />,
    editor: (props) => <Editor {...props} />,
    fields: (props) => <Fields {...props} />,
    tooltipSystem: (props) => <TooltipSystem {...props} />,
    button: (props) => <Button {...props} />,
    inputBase: (props) => <InputBase {...props} />,
    spaceBetween: (props) => <SpaceBetween {...props} />,
    empty: (props) => <div />,
    checkbox: (props) => <CheckBox {...props} />,
    autoComplete: (props) => <AutoComplete {...props} />,
    dataGrid: (props) => <DataGrid {...props} permissionHOC="gridColumn" />,
    label: (props) => <Label {...props} />,
    divider: (props) => <Divider {...props} />,
    gender: (props) => <Gender {...props} />,
    iconButton: (props) => <IconButton {...props} />,
    comment: (props) => <Comment {...props} />,
}

export default fieldsTyps 